import React from "react";
import Modal from "react-bootstrap/Modal";
import "./roleListPopup.css";
import Button from "../ThemeButton/ThemeButton";
import PropTypes from "prop-types";
import SuccessPopupIcon from "../../assets/images/success-popup.svg";

const RoleListPopup = ({
  show,
  setShow,
  selectPlaceholder,
  values,
  selectNum,
  label,
  handleSelectData,
  handleSubmit,
  handleCancel,
  roleValidate,
  labelText,
  defaultValue,
  style
}) => {
  return (
    <div>
      <Modal show={show} className="alertBoxModal popupAlert popSuccessAlert roleDataPopup">
        <div className="contentContainerConfirmAlert">
          <Modal.Header closeButton>
            <Modal.Title>Assign roles</Modal.Title>
            <div className="subheading">Select role to assign in bulk.</div>
            <div className="modalBody selectData">
              <label>{labelText}</label>
              <select
                value={defaultValue}
                onChange={handleSelectData}
                style={style}
              >
                <option value="">{selectPlaceholder}</option>
                {values.map((item, index) => (
                  <option key={index} value={item[selectNum]}>
                    {item[label]}
                  </option>
                ))}
              </select>
              <div className="validationData">
        <p className="mb-0 error-msg">{roleValidate ? roleValidate : ""}</p>
      </div>
            </div>
          </Modal.Header>
          <Modal.Footer>
            <div className="btnSuccessAlert handleBulkUploadBtns">
            <div className="buttonOk">
            <div className="roleCancelBt">
              <Button value="Cancel" onClick={handleCancel}></Button>
              </div>
              <Button value="Submit" onClick={handleSubmit}></Button>
              </div>
            </div>
          </Modal.Footer>
        </div>
      
      </Modal>

    </div>
  );
};

export default RoleListPopup;
